import { augmentErrorMessage } from "@configura/web-utilities";
import { CfgProdConfParts, compactStringToDtoProductConf, dtoProductConfigurationToCompactString, } from "../utilitiesConfiguration.js";
import { CfgHistoryManager } from "./CfgHistoryManager.js";
import { CfgIOProdConfConnector, CfgProdConfMessageVersions, getHighestVersionProdConfMessage, isCfgProdConfMessageV2, STAGE_PROD_CONF_MESSAGE_KEY, } from "./CfgIOProdConfConnector.js";
/**
 * Instantiating this will make the browser history (and URL) update with the product configuration.
 */
export class CfgHistoryToProdConfConnector extends CfgIOProdConfConnector {
    /**
     * @param _mode
     * @param _qsKey The Query String key for product configuration.
     */
    constructor(manager, _mode, _qsKey) {
        super(manager, CfgProdConfParts.SyncGroupState);
        this._mode = _mode;
        this._qsKey = _qsKey;
    }
    static getInitialProdConf(qsKey) {
        // First try to use the state, if that doesn't work use the query string
        const initialMessage = CfgHistoryManager.getMessageFromCurrentHistoryState(STAGE_PROD_CONF_MESSAGE_KEY);
        if (initialMessage !== undefined) {
            const highestVersionMessage = getHighestVersionProdConfMessage(initialMessage.subMessages);
            if (isCfgProdConfMessageV2(highestVersionMessage)) {
                return highestVersionMessage.conf;
            }
        }
        try {
            const s = CfgHistoryManager.currentQsKeyValues().get(qsKey);
            if (s === undefined) {
                return undefined;
            }
            return compactStringToDtoProductConf(s);
        }
        catch (err) {
            throw augmentErrorMessage(err, "Failed read configuration from query string");
        }
    }
    static make(manager, mode, qsKey = STAGE_PROD_CONF_MESSAGE_KEY) {
        const initial = this.getInitialProdConf(qsKey);
        const instance = new CfgHistoryToProdConfConnector(manager, mode, qsKey);
        return { instance, initial };
    }
    makeSendData(conf, initial) {
        return {
            message: CfgIOProdConfConnector.makeMessage(conf, initial, CfgProdConfMessageVersions.V2dot0),
            qsKeyValues: new Map([[this._qsKey, dtoProductConfigurationToCompactString(conf)]]),
            mode: this._mode,
        };
    }
}
